export enum QuestActivationSource {
  HOME_PAGE = 'HOME_PAGE',
  REWARDS_REDEEM = 'REWARDS_REDEEM',
  REWARDS_PROFILE = 'REWARDS_PROFILE',
  DEEP_LINK = 'DEEP_LINK',
  UNKNOWN = 'UNKNOWN',
}

const QUEST_ACTIVATION_SOURCES = new Set<string>(Object.values(QuestActivationSource));

export const parseQuestActivationSource = (
  value: string | undefined | null
): QuestActivationSource => {
  if (value && QUEST_ACTIVATION_SOURCES.has(value)) {
    return value as QuestActivationSource;
  }

  return QuestActivationSource.UNKNOWN;
};
